import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Toaster } from '@/components/ui/toaster';
import useAnalytics from '@/hooks/useAnalytics';

// Layouts
import PublicLayout from '@/layouts/PublicLayout';
import AdminLayout from '@/layouts/AdminLayout';

// Admin Pages
import AdminLogin from '@/pages/admin/AdminLogin';
import DashboardHome from '@/pages/admin/DashboardHome';
import GenericCatalogManager from '@/pages/admin/GenericCatalogManager';
import ProductManager from '@/pages/admin/ProductManager';

// Public Pages
import Home from '@/pages/Home';
import Products from '@/pages/Products';
import Nosotros from '@/pages/Nosotros';
import Contact from '@/pages/Contact';
import ProductDetail from '@/pages/ProductDetail';
import AutomobileDetail from '@/pages/AutomobileDetail';
import BoxingGlovesDetail from '@/pages/BoxingGlovesDetail';
import CookiePolicy from '@/pages/CookiePolicy';
import AvisoPrivacidad from '@/pages/AvisoPrivacidad';

// Componente para manejar las rutas animadas públicas
const AnimatedPublicRoutes = () => {
  const location = useLocation();

  return (
    <PublicLayout>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/productos" element={<Products />} />
        <Route path="/producto/:productId" element={<ProductDetail />} />
        <Route path="/automotriz" element={<AutomobileDetail />} />
        <Route path="/guantes-box" element={<BoxingGlovesDetail />} />
        <Route path="/nosotros" element={<Nosotros />} />
        <Route path="/contacto" element={<Contact />} />
        <Route path="/politica-cookies" element={<CookiePolicy />} />
        <Route path="/aviso-de-privacidad" element={<AvisoPrivacidad />} />
      </Routes>
    </PublicLayout>
  );
};

const AnalyticsTracker = () => {
  useAnalytics();
  return null;
};

function App() {
  return (
    <Router>
      <AnalyticsTracker />
      <Toaster />
      <Routes>
        {/* RUTAS DE ADMINISTRADOR (Aisladas y Protegidas) */}
        <Route path="/admin" element={<AdminLogin />} />

        {/* Dashboard con subrutas */}
        <Route path="/admin/dashboard/*" element={<AdminLayout />}>
          <Route index element={<DashboardHome />} />

          {/* Rutas de Catálogos CRUD */}
          <Route path="base-productos" element={<GenericCatalogManager table="producto" />} />
          <Route path="categorias" element={<GenericCatalogManager table="categoria" />} />
          <Route path="colores" element={<GenericCatalogManager table="color" />} />
          <Route path="materiales" element={<GenericCatalogManager table="material" />} />
          <Route path="texturas" element={<GenericCatalogManager table="textura" />} />
          <Route path="presentaciones" element={<GenericCatalogManager table="presentacion" />} />
          <Route path="diametros" element={<GenericCatalogManager table="diametro" />} />
          <Route path="disenada_para" element={<GenericCatalogManager table="disenada_para" />} />
          <Route path="bases" element={<GenericCatalogManager table="base" />} />

          {/* Próximamente: Productos */}
          <Route path="productos" element={<ProductManager />} />
        </Route>

        {/* RUTAS PÚBLICAS (Catch-all para todo lo demás) */}
        <Route path="/*" element={
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <AnimatedPublicRoutes />
          </motion.div>
        } />
      </Routes>
    </Router>
  );
}

export default App;